<template>
  <section id="gallery-dashboard">
    <div class="section padding-page-top padding-bottom over-hide">
      <div class="container ">
        <div class="row page-title px-4 px-xl-2">
          <div class="col-12 parallax-fade-top">
            <h1>Gallery Portal</h1>
          </div>
          <div class="offset-1 col-11 parallax-fade-top mt-2 mt-sm-3">
            <p class="tab" @click="changeTab">
              <span
                data-tab="ImageModify"
                :class="{
                  active: ComponentsToRender == 'ImageModify'
                }"
                >Modify Pictures</span
              >
              <span
                data-tab="ImageUpload"
                class="ml-4 ml-xl-5"
                :class="{
                  active: ComponentsToRender == 'ImageUpload'
                }"
                >Upload Pictures</span
              >
            </p>
          </div>
        </div>
        <div class="col-12 mt-5">
          <transition name="slide" mode="out-in">
            <component :is="ComponentsToRender" />
          </transition>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { EventBus } from "../main";
import { ParallaxEffect } from "@/components/utils";
import ImageUpload from "@/components/ImageUpload";
import ImageModify from "@/components/ImageModify";

export default {
  data() {
    return {
      loading: false,
      ComponentsToRender: "ImageModify"
    };
  },
  components: {
    ImageUpload,
    ImageModify
  },
  methods: {
    changeTab(event) {
      if (event.target.getAttribute("data-tab") != null)
        this.ComponentsToRender = event.target.getAttribute("data-tab");
    }
  },
  mounted() {
    EventBus.$emit(
      "allLinks",
      document.querySelectorAll(".action, .tag, .mark-delete, tab")
    );
    ParallaxEffect(this.$el);
  }
};
</script>

<style lang="scss" scoped>
.tab {
  span {
    opacity: 0.4;
    cursor: pointer;

    &.active {
      position: relative;
      opacity: 1;
      &::after {
        content: "";
        position: absolute;
        background-color: $primary;
        height: 20%;
        width: 100%;
        bottom: 0;
        left: 0;
        z-index: -1;
      }
    }
  }
}
.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: 0.3s all ease;
}
</style>
